<template>
  <div class="listPage">
    <div class="nwrap">
      <div class="nei_ban">
        <img :src="indexImg" style="width: 100%; height: 100%" />
        <h3>{{slideHdName}}<p></p></h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <ul class="fl_list">
          <li v-for="(item, index) in slideList" :key="index" :class="{on : active  == item.entTChannelUuid}">
            <a
              v-if="item.url && item.url !== ''" 
              :href="item.url">
              {{item.name}}
            </a>
            <a 
              v-if="!item.url || item.url == ''" 
              :href="item.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog === 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
              {{item.name}}
            </a>
          </li>
        </ul>
      </div>
      <div class="clear ptb3"></div>
      <div class="ab_tit">
        <h3>{{slideHdName}}</h3>
        <i></i>
      </div>
      <div class="clear ptb2"></div>
      <div class="clear ptb3"></div>
      <div class="listContainer">
        <div class="detailCont" v-html="pageCont"></div>
      </div>
      <div class="clear ptb2"></div>
      <div class="clear ptb3"></div>
    </div>
  </div>
</template>

<script>
import { getChildChannel, getChannelInfo, getArtInfoByChannel,increaseViews ,getCookie } from '@/api/common'

export default {

  data(){
    return {
      indexImg: '',
      slideHdTitle: '',
      viewSlideHdParent: true,
      slideHdParentName: '',
      slideHdParentUrl: '',
      slideHdName: '',
      pageCont: '',
      active: 0,
      slideList:[],
      listData: [],
      applicationUuid:'',
      lang: 'zh-CN',
    }
  },
  mounted(){
    var _this = this
    _this.active = _this.$route.params.id
    _this.listId = _this.$route.params.id

    let lang = getCookie('lang')
    if( lang == 'en-US'){
      this.applicationUuid = this.webIdEn
    }
    else {
      this.applicationUuid = this.webId
    }

    _this.getChannelInfo()
    _this.getArtInfoByChannel()
  },
  methods: {
    // 查询二级栏目
    getChildChannel(id) {
      var _this = this
      let data = {
        applicationUuid: this.applicationUuid,
        parentUuid: id
      }
      getChildChannel(data).then(res => {
        const {
          code,
          data
        } = res
        if (code === 1 && data) {
          _this.slideList = data
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true
            let url = ''
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`
            } else {
              url = `/list/${_this.slideList[0].entTChannelUuid}`
            }
            _this.slideHdParentUrl = url
          } else {
            _this.viewSlideHdParent = false
          }
        }
      })
    },
    getChannelInfo() {
      var _this = this
      let data = {
        channelUuid: _this.$route.params.id
      }
      getChannelInfo(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.slideHdName = data.name
          if (data.parentUuid == "0") {
            _this.slideHdTitle = data.name
            _this.viewSlideHdParent = false
            if(data.fileName && data.fileName !== ''){
              _this.indexImg = data.fileName
            }
            else{
              _this.indexImg = require('../assets/image/partyBuilding.jpg')
            }
            return
          }

          _this.getChildChannel(data.parentUuid)

          let params = {
            channelUuid: data.parentUuid
          }
          getChannelInfo(params).then(res => {
            const { code, data } = res
            if (code === 1 && data) {
              _this.slideHdParentName = data.name
              _this.slideHdTitle = data.name
              if(data.fileName && data.fileName !== ''){
                _this.indexImg = data.fileName
              }
              else{
                _this.indexImg = require('../assets/image/partyBuilding.jpg')
              }
            }
          })
        }
      })
    },
  
    getArtInfoByChannel() {
      var _this = this
      let data = {
        entTApplicationUuid: this.applicationUuid,
        channelUuid: _this.$route.params.id
      }
      getArtInfoByChannel(data).then(res => {
        const {
          code,
          data
        } = res
        if (code === 1 && data) {
          _this.pageCont = data.content
          this.increaseViews(data.entTArticleUuid)
        }
      })
    },
    increaseViews(id){
      let data = {
        entTArticleUuid: id
      }
      increaseViews(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          // _this.dataView = data
          // console.log(111,_this.dataView)
        }
      })
    }
  }
}
</script>
<style>
.listPage .nei_ban {
  clear: both;
  width: 100%;
  height: 270px;
}
.listPage .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #fff;
  font-weight: normal;
  margin-top: -175px;
}
.listPage .nei_ban p {
  font-size: 24px;
  color: #fff;
  text-transform: uppercase;
}
.listPage .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.listPage .ptb3 {
  padding-top: 3%;
}
.listPage .wrap {
  width: 1200px;
  margin: 0 auto;
}
.listPage .listContainer{
  width: 1200px;
  margin: 0 auto;
}
.listPage .fl_list {
  clear: both;
  display: table;
  text-align: center;
  margin: 0 auto;
}
.listPage .fl_list li {
  float: left;
  margin: 0 20px;
  display: block;
}
.listPage .fl_list li a {
  background: #b9b9b9;
  display: block;
  padding: 12px 18px;
  font-size: 18px;
  color: #FFF;
  border-radius: 5px;
}
.listPage .fl_list li.on a{
background: #0062b1;
}
.listPage .ab_tit {
  clear: both;
  width: 100%;
  text-align: center;
}
.listPage .ab_tit h3 {
  font-size: 30px;
  color: #333;
  font-weight: bold;
}
.listPage .ab_tit i {
  display: block;
  width: 50px;
  height: 2px;
  background: #0062b1;
  margin: 0 auto;
  margin-top: 20px;
}
.listPage .detailCont{
font-size: 16px;
color: #333;
}
.detailCont .ab_txt_txt {
  float: left;
  width: 50%;
  line-height: 26px;
} 
@media (max-width: 1300px) {
.listPage .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
}
@media (max-width: 1000px) {
.listPage .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.listPage .fl_list li {
  float: left;
  width: 20%;
  margin: 0px 1%;
  margin-bottom: 10px;
  display: block;
}
.listPage .listContainer{
  width: 90%;
}
}
@media (max-width: 992px) {
.listPage .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.listPage .fl_list li {
  float: left;
  width: 30%;
  margin: 0px 1%;
  margin-bottom: 10px;
  display: block;
}
.listPage .listContainer{
  width: 90%;
}
.detailCont .ab_txt_txt {
  float: left;
  width: 100%;
  line-height: 26px;
} 
}
@media (max-width: 768px) {
.listPage .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.listPage .fl_list li {
  float: left;
  width: 48%;
  margin: 0px 1%;
  margin-bottom: 10px;
  display: block;
}
.listPage .listContainer{
  width: 90%;
}
.detailCont .ab_txt_txt {
  float: left;
  width: 100%;
  line-height: 26px;
} 
}
</style>